import React from 'react';
import { Col, Row, Tooltip } from 'antd';
import SectionTitle from 'components/Section/SectionTitle';
import Image from 'components/Image';
import Link from 'next/link';
import { styled } from 'styled-components';

type Props = {
    companies: Company[];
};

const Container = styled.div`
    @media (min-width: 992px) {
        max-height: 50%;
        top: 0;
        position: sticky;
    }
`;

export const SponsoredArticleSection = ({ companies }: Props) => {
    const span = companies.length > 3 ? 12 : 24;
    const imageDimensions =
        companies.length === 3 ? { width: 240, height: 240 } : { width: 272, height: 272 };
    return (
        <Container>
            <Row style={{ background: 'white', padding: '10px 0 30px 0' }}>
                <Col span={24}>
                    <SectionTitle level={2} title="Profil Firmy" />
                </Col>
                {companies.map((company) => (
                    <Col key={company.seoSlug} span={span}>
                        <Row justify="center">
                            <Col>
                                <Link href={`/katalog-firm/${company.seoSlug}`}>
                                    <Tooltip title={company.name}>
                                        <Image
                                            type="logo"
                                            src={company.logo}
                                            alt={company.name}
                                            width={imageDimensions.width}
                                            height={imageDimensions.height}
                                        />
                                    </Tooltip>
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default SponsoredArticleSection;
